<template>
    <div :class="'pb-3 timeline-item timeline-item-'+position">
        <div :class="'bg-'+(bgColor? bgColor : 'secondary')+' text-white timeline-mark timeline-mark-'+position">
            <i class="fas fa-user-check"></i> 
        </div>
        <span :class="'timeline-time timeline-time-'+position"></span>
        <slot></slot>
    </div>
</template>

<script>
import Axios from 'axios';
export default {
    props: [
        'position',
        'bgColor',
    ],
    data() { return {
        
    }},
    mounted() {
        
    },
    methods: {
        
    }
}
</script>